import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { format, parseISO } from "date-fns";
import apiDiarioOperacao from "../../services/apis/apiDiarioOperacao";
import { useToast } from "../../contexts/ToastContext";
import { Button } from "../ui/button";



export default function ConfirmarDelete({ itemToDelete, setItemToDelete, updateList }) {

    const { sucesso, erro} = useToast();

    const deletarRegistro = async (id) => {
        try {
            await apiDiarioOperacao.delete(id);
            sucesso("Registro deletado com sucesso!");
            updateList(1);
        } catch (error) {
            erro("Erro ao deletar o registro. Tente novamente.")
        }
    }


    return (
        itemToDelete &&
<Dialog 
    open={!!itemToDelete} 
    onOpenChange={(open) => !open && setItemToDelete(null)}
>            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        Excluir registro do dia {format(parseISO(itemToDelete?.data), "dd/MM/yyyy")} feito por {itemToDelete?.nomeCompleto}?
                    </DialogTitle>
                </DialogHeader>
                <DialogFooter>
                    <Button onClick={() => setItemToDelete(null)}>Cancelar</Button>
                    <div
                        className="bg-red-600/70 py-2 px-4 rounded-md hover:bg-red-600 hover:cursor-pointer border-slate-800 border-2 transition-all duration-200 ease-in-out"
                        onClick={() => deletarRegistro(itemToDelete?.id)}
                    >
                        <DialogClose>Excluir</DialogClose>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}